import { useRouter } from "next/router";
import { ReviewsUI } from "./ReviewsUI";
import { StandardProps } from "../componentMap";
import { getBaseUrlAndQuery } from "@/utils/url/getBaseUrlAndQuery";

export function Reviews({
  product,
  runtimeConfig,
  configProps,
  experiencesRawObject,
}: Pick<
  StandardProps,
  "product" | "runtimeConfig" | "configProps" | "experiencesRawObject"
>) {
  const { asPath } = useRouter();
  const { baseUrl } = getBaseUrlAndQuery(asPath);
  const { reviewsApiKey, reviewsScriptUrl } = runtimeConfig;
  return (
    <ReviewsUI
      productId={product.aliases.pimProductId}
      reviewsApiKey={reviewsApiKey}
      reviewsScriptUrl={reviewsScriptUrl}
      productUrl={baseUrl}
      numberOfReviews={product.reviewSummary?.numberOfReviews}
      media={configProps?.hideReviewsMedia ? "false" : "true"}
      experiencesRawObject={experiencesRawObject}
    />
  );
}
